import Link from "next/link";
import FAIcon from "@/components/icons/faIcon";

const PANEL_WIDTH = 440;
const PANEL_SURFACE = "bg-neutral-50";
const PANEL_GLOW = "shadow-[0_34px_110px_rgba(6,4,12,0.18)]";
const DROPDOWN_SHADOW = "shadow-3xl shadow-blackq/20";

const ITEMS = [
  {
    title: "Our Clients",
    description:
      "See which organisations trust SML for their health and safety consultancy.",
    href: "/our-clients",
  },
  {
    title: "About us",
    description:
      "Read about SML, our background and the practical approach behind our consultancy work.",
    href: "/about-us",
  },
  {
    title: "News",
    description:
      "Browse company updates, insights and announcements from the SML team.",
    href: "/news",
  },
];

function MenuArrowIcon({ className = "", noMargin = false, size }) {
  return (
    <FAIcon
      icon="arrow-right"
      className={className}
      noMargin={noMargin}
      size={size}
    />
  );
}

const LIGHT_CARD_SURFACE = "bg-white";

function DesktopDropdown({ id, onNavigate }) {
  return (
    <div
      id={id}
      style={{ width: `${PANEL_WIDTH}px`, maxWidth: "calc(100vw - 2.5rem)" }}
      className={`relative overflow-hidden rounded-lg p-8 ${PANEL_GLOW} ${DROPDOWN_SHADOW} ${PANEL_SURFACE}`}
    >
      <div className="grid gap-3 md:grid-cols-1">
        {ITEMS.map((item) => (
          <Link
            key={item.title}
            href={item.href}
            onClick={onNavigate}
            className={`group flex min-h-24 flex-col justify-between rounded-lg p-4 transition-all duration-300 hover:-translate-y-0.5 ${LIGHT_CARD_SURFACE}`}
          >
            <div className="space-y-3">
              <div className="space-y-3">
                <div className="flex items-center justify-between gap-3">
                  <h4 className="max-w-sm text-[1.4rem] font-medium leading-[1.04] tracking-[-0.05em] text-[#06040c]">
                    {item.title}
                  </h4>
                  <MenuArrowIcon className="h-4 w-4 shrink-0 text-[#06040c]/38 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-[#06040c]" />
                </div>

                <p className="mt-2 max-w-md text-sm leading-6 text-[#06040c]/64">
                  {item.description}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

function MobileContent({ onNavigate }) {
  return (
    <div className="space-y-1.5  pb-2.5">
      {ITEMS.map((item) => (
        <Link
          key={item.title}
          href={item.href}
          onClick={onNavigate}
          className="flex min-w-0 items-start justify-between gap-3 rounded-md bg-white px-3.5 py-2.5"
        >
          <div className="min-w-0">
            <p className="text-md font-semibold text-[#06040c]">{item.title}</p>
            <p className="mt-1 text-[0.84rem] leading-4.5 text-[#06040c]/64">
              {item.description}
            </p>
          </div>
          <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary text-[#06040c]">
            <MenuArrowIcon className="mx-auto" noMargin size={14} />
          </span>
        </Link>
      ))}
    </div>
  );
}

const companyMenu = {
  label: "Company",
  DesktopDropdown,
  MobileContent,
};

export default companyMenu;
